<template>
  <div class="view-user">
    <div class="container-fluid mt-3">
      <div class="card">
        <form @submit="editUser">
          <div class="card-header">
            <h5><i class="fa fa-user-alt" /> User Details</h5>
            <div class="text-right">
              <button
                type="submit"
                class="btn btn-warning btn-sm font-weight-bold"
              >
                <i class="fas fa-user-edit" /> {{ editableUser ? 'UPDATE':'EDIT' }}
              </button>
                            &nbsp;&nbsp;
              <button
                type="button"
                class="btn btn-outline-secondary btn-sm font-weight-bold"
                @click="goBack"
              >
                <i class="fas fa-backward" />
                GO BACK
              </button>
            </div>
          </div>

          <div class="card-body">
            <div
              class="form-group row"
              :class="{'has-error': errorUpdateUser.employee_id !==''}"
            >
              <div class="form-group col-sm-4">
                <label
                  for="employee_id"
                  class="font-weight-bolder"
                >Employee Id</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="user.employee_id"
                  :readonly="!editableUser"
                  @input="capitalize($event, employee_id, 'employee_id')"
                  id="employee_id"
                  name="employee_id"
                  placeholder="Employeeid"
                >

                <span
                  class="invalid-feedback"
                  v-if="errorUpdateUser.employee_id!== '' "
                >
                  <small><strong>{{ errorUpdateUser.employee_id }}</strong></small>
                </span>
              </div>


              <div class="form-group col-sm-4">
                <label class="font-weight-bolder">Created Date:</label>
                <small class="form-control-sm">{{ user.created_at | moment('D MMM YYYY hh:m A') }}</small>
              </div>

              <div class="form-group col-sm-4">
                <label class="font-weight-bolder">Updated Date:</label>
                <small class="form-control-sm">{{ user.updated_at | moment('D MMM YYYY hh:m A') }}</small>
              </div>
            </div>


            <div class="form-group row">
              <div class="form-group col-sm-4">
                <label
                  for="last_name"
                  class="font-weight-bolder"
                >Last Name</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="user.last_name"
                  :readonly="!editableUser"
                  @input="capitalize($event, last_name, 'last_name')"
                  id="last_name"
                  name="last_name"
                  placeholder="Last Name"
                >
              </div>

              <div class="form-group col-sm-4">
                <label
                  for="name"
                  class="font-weight-bolder"
                >First Name</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="user.name"
                  :readonly="!editableUser"
                  @input="capitalize($event, name, 'name')"
                  id="name"
                  name="name"
                  placeholder="First Name"
                >
              </div>

              <div class="form-group col-sm-4">
                <label
                  for="middle_name"
                  class="font-weight-bolder"
                >Middle Name</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="user.middle_name"
                  :readonly="!editableUser"
                  @input="capitalize($event, middle_name, 'middle_name')"
                  id="middle_name"
                  name="middle_name"
                  placeholder="Middlename"
                >
              </div>
            </div>

            <div class="form-group row">
              <div class="form-group col-md-12">
                <label
                  for="address"
                  class="font-weight-bolder"
                >Address</label>
                <input
                  class="form-control"
                  v-model="user.address"
                  :readonly="!editableUser"
                  @input="capitalize($event, address, 'address')"
                  id="address"
                  name="address"
                  placeholder="Address"
                >
              </div>
            </div>


            <div class="form-group row">
              <div class="form-group col-sm-4">
                <label
                  for="username"
                  class="font-weight-bolder"
                >Username</label>
                <input
                  class="form-control"
                  v-model="user.username"
                  :readonly="!editableUser"
                  @input="capitalize($event, username, 'username')"
                  id="username"
                  name="address"
                  placeholder="Username"
                >
              </div>

              <div class="form-group col-sm-4">
                <label
                  for="userType"
                  class="font-weight-bolder"
                >User Type</label>

                <select
                  class="form-control"
                  name="user_type_id"
                  id="userType"
                  v-model="user.user_type_id"
                  :disabled="!editableUser"
                >
                  <option
                    v-for="userType in userTypes"
                    :selected="user.user_type_id === userType.id"
                    :value="userType.id"
                    :key="userType.id"
                  >
                    {{ userType.name }}
                  </option>
                </select>
              </div>


              <div class="form-group col-sm-4">
                <label
                  for="email"
                  class="font-weight-bolder"
                >Email</label>
                <input
                  type="email"
                  class="form-control"
                  v-model="user.email"
                  :readonly="!editableUser"
                  @input="capitalize($event, email, 'email')"
                  id="email"
                  name="email"
                  placeholder="Email"
                >
              </div>
            </div>


            <div class="form-group row">
              <div class="form-group col-sm-1">
                <label
                  for="userStatus"
                  class="font-weight-bolder"
                >Status</label>
                <input
                  type="checkbox"
                  name="status"
                  id="userStatus"
                  class="form-control"
                  v-model="user.status"
                  :disabled="!editableUser"
                >
              </div>

              <div class="col-md-2 col-form-label font-weight-bold border-0">
                <span
                  id="statusTag"
                  v-if="user.status == 1"
                  class="font-weight-bolder text-success"
                >ACTIVE</span>
                <span
                  id="statusTag1"
                  v-else-if="user.status !== 1"
                  class="font-weight-bolder text-danger"
                >INACTIVE</span>
              </div>
            </div>
          </div>


          <div class="card-footer" />
        </form>
      </div>
    </div>
  </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import { formMixins } from '../../../mixins/formMixins';
    export default {
        mixins:[formMixins],
        props: ['id'],
        name: 'ViewUser',

        methods: {
            ...mapActions(['viewUser','setEditableUser','updateUser']),
            async editUser(e) {
                e.preventDefault();
                if(this.editableUser) {
                    if(await this.confirmUpdateAlert('Are you sure you want to update this user?')){
                        this.updateUser(this.user);
                    }
                }
                this.setEditableUser();
            },

            cancelEdit() {

            },
        },

        computed: {
            ...mapGetters(['user','errorUpdateUser','editableUser','userTypes']),
        },

        created() {
            //this.viewVesselType(this.id);
            this.viewUser(this.id);
        }
  };
</script>

<style scoped>

</style>
